import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { Media } from '../Media';
import { DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE } from '../../constants';
import { MediaBody } from '../MediaBody';
import { MediaLeft } from '../MediaLeft';
import { MediaRight } from '../MediaRight';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MediaObject = _ref => {
  let {
      children,
      itemLeft,
      itemRight,
      MediaBody: _MediaBody = MediaBody,
      MediaLeft: _MediaLeft = MediaLeft,
      MediaRight: _MediaRight = MediaRight,
      [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: dataComponentAttribute
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, ["children", "itemLeft", "itemRight", "MediaBody", "MediaLeft", "MediaRight", DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE].map(_toPropertyKey));
  return /*#__PURE__*/_jsxs(Media, Object.assign({}, rest, {
    [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: dataComponentAttribute || 'MediaObject',
    children: [itemLeft ? /*#__PURE__*/_jsx(_MediaLeft, {
      children: itemLeft
    }) : null, /*#__PURE__*/_jsx(_MediaBody, {
      children: children
    }), itemRight ? /*#__PURE__*/_jsx(_MediaRight, {
      children: itemRight
    }) : null]
  }));
};
MediaObject.displayName = 'MediaObject';